import {
  addOrRemoveItem,
  toggleFeature,
  addAllFeatures,
  toggleEpic,
  addAllEpics,
} from './reducer_functions';

export default function (state, action) {
  switch (action.type) {
    case 'TOGGLE_RELEASE_CUSTOM_FIELD':
      return addOrRemoveItem(
        state,
        ['bookmark', 'releaseCustomFields'],
        action.payload.toggle,
        action.payload.fieldId
      );

    case 'TOGGLE_FEATURE_CUSTOM_FIELD':
      return addOrRemoveItem(
        state,
        ['bookmark', 'featureCustomFields'],
        action.payload.toggle,
        action.payload.fieldId
      );

    case 'FEATURE_TOGGLE':
      toggleFeature(
        action.payload.active,
        state.get('bookmark').get('id'),
        action.payload.featureId
      );
      return addOrRemoveItem(
        state,
        ['bookmark', 'shownInNotebookIds'],
        action.payload.active,
        action.payload.featureId
      );

    case 'RECORD_SHOWALL': {
      const release = action.payload.release;
      const timelineType = state.get('bookmark').get('timelineType');
      const recordType = timelineType === 'epic' ? 'epics' : 'features';

      if (timelineType === 'epic') {
        addAllEpics(state.get('bookmark').get('id'), release.get('id'));
      } else {
        addAllFeatures(state.get('bookmark').get('id'), release.get('id'));
      }

      const shownFeatures = state.get('bookmark').get('shownInNotebookIds');
      const releaseFeatures = release
        .get(`${recordType}`)
        .map(record => record.get('id'));

      // Combine two lists and remove duplicates
      const newFeatures = shownFeatures
        .concat(releaseFeatures)
        .toSet()
        .toList();

      return state.setIn(['bookmark', 'shownInNotebookIds'], newFeatures);
    }

    case 'UPDATE_COLUMNS_SCROLL_POSITION':
      return state.setIn(
        ['bookmark', 'scrollPosition'],
        action.payload.scrollPosition
      );

    case 'TOGGLE_EPIC_CUSTOM_FIELD':
      return addOrRemoveItem(
        state,
        ['bookmark', 'epicCustomFields'],
        action.payload.toggle,
        action.payload.fieldId
      );

    case 'EPIC_TOGGLE':
      toggleEpic(
        action.payload.active,
        state.get('bookmark').get('id'),
        action.payload.epicId
      );
      return addOrRemoveItem(
        state,
        ['bookmark', 'shownInNotebookIds'],
        action.payload.active,
        action.payload.epicId
      );

    default:
      return state;
  }
}
